import { render, staticRenderFns } from "./RiskPdf.vue?vue&type=template&id=7ecc364a&scoped=true&"
import script from "./RiskPdf.vue?vue&type=script&lang=js&"
export * from "./RiskPdf.vue?vue&type=script&lang=js&"
import style0 from "./RiskPdf.vue?vue&type=style&index=0&id=7ecc364a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecc364a",
  null
  
)

export default component.exports